import React, { useState, useEffect } from "react";
import confetti from "canvas-confetti";
import "./game.css";

import helmLogo from "./assets/Helm.svg";
import dragonImg from "./assets/Dragon.svg";
import infinityImg from "./assets/infinity.svg";
import shipImg from "./assets/ship.png"; // Make sure this is in your assets folder

const pyramidRows = [
  ["frame"], // top winner
  ["dragon", "normal"],
  ["normal", "normal", "dragon"],
  ["normal", "dragon", "normal", "normal"],
  ["normal", "normal", "normal", "dragon", "normal"],
];

const iconsMap = {
  frame: helmLogo,
  dragon: dragonImg,
  normal: null,
};

export default function GamePyramid() {
  const flatBlocks = pyramidRows.flat();
  const totalSteps = flatBlocks.length;

  // Player starts at step 15 (index 14)
  const [playerPos, setPlayerPos] = useState(14);
  const [isDragonEncountered, setIsDragonEncountered] = useState(false);

  const currentBlockType = flatBlocks[playerPos];

  useEffect(() => {
    setIsDragonEncountered(currentBlockType === "dragon");
  }, [currentBlockType]);

  useEffect(() => {
    if (currentBlockType === "frame") {
      confetti({
        particleCount: 300,
        spread: 120,
        origin: { y: 0.3 },
      });
    }
  }, [currentBlockType]);

  const moveForward = () => {
    if (playerPos < totalSteps - 1) {
      setPlayerPos(playerPos + 1);
    }
  };

  const resolveDragon = () => {
    setIsDragonEncountered(false);
    moveForward();
  };

  const renderPyramid = () => {
    let index = 0;
    return pyramidRows.map((row, rowIndex) => (
      <div
        key={rowIndex}
        className="pyramid-row"
        aria-label={`Row ${rowIndex + 1}`}
      >
        {row.map((blockType, colIndex) => {
          const isPlayerHere = index === playerPos;
          const imgSrc = iconsMap[blockType];
          const isDragon = blockType === "dragon";
          const isFrame = blockType === "frame";

          const className = [
            "block",
            isPlayerHere ? "player-active" : "",
            isDragon ? "dragon-block" : "",
            isFrame ? "frame-block" : "",
          ].join(" ");

          const content = isPlayerHere ? (
            <img src={infinityImg} alt="Player Icon" className="player-icon" />
          ) : imgSrc ? (
            <img
              src={imgSrc}
              alt={`${blockType} icon`}
              className={`${blockType}-icon`}
            />
          ) : null;

          const stepNumber = index + 1;
          index++;

          return (
            <div
              key={colIndex}
              className={className}
              title={`Step ${stepNumber}: ${blockType}`}
              role="button"
              aria-pressed={isPlayerHere}
              tabIndex={0}
            >
              {content}
              <div className="step-number">{stepNumber}</div>
            </div>
          );
        })}
      </div>
    ));
  };

  return (
    <div className="game-pyramid-container">
      <h1 className="title">🐉 Kubernetes Chaos Pyramid 🏆</h1>
      <div className="game-area">
        <div className="pyramid-board">{renderPyramid()}</div>

        <div className="controls-panel">
          <div className="controls">
            {isDragonEncountered && (
              <button onClick={resolveDragon} className="solve-dragon-btn">
                🐉 Solve Chaos Attack!
              </button>
            )}
          </div>

          <h3>Kubernetes CLI</h3>

          <iframe
            src="http://13.234.238.137:7681"
            title="Kubernetes CLI Terminal"
            className="cli-iframe"
            aria-label="Kubernetes Command Line Interface"
          />

          <div className="ship-container">
            <img src={shipImg} alt="Cruising Ship" className="cruising-ship" />
          </div>
        </div>
      </div>
    </div>
  );
}
